import { action } from 'typesafe-actions';

import { SET_DEFAULT_BIN_OVERAGE } from './constants';

export const setDefaultBINOverage = (overage: number) => action(SET_DEFAULT_BIN_OVERAGE, overage);
